import * as React from "react";
import { Form, Icon, Input, Button, Progress } from "antd";
const FormItem = Form.Item;

import { FormComponentProps } from "antd/lib/form";
import { Mutation, MutationFn } from "react-apollo";
import { Link } from "react-router-dom";
import { REQUEST_RESET_QUERY } from "./queries";
import {
  RequestReset,
  RequestResetVariables
} from "../../../__generated__/types";
import Logo from "../../../components/Logo";

export interface Props extends FormComponentProps {
  children?: React.ReactNode;
}

export interface State {
  loading: boolean;
  done: boolean;
}

class RequestResetMutation extends Mutation<RequestReset> {}

export class ForgotForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { loading: false, done: false };
  }

  handleReset(
    event: React.FormEvent<HTMLFormElement>,
    reset: MutationFn<RequestReset, RequestResetVariables>
  ) {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (reset) {
          this.setState({ loading: true });
          console.log(values);
          reset({
            variables: {
              email: values.email
            }
          })
            .then(response => {
              this.setState({ loading: false, done: true });
            })
            .catch(error => {
              console.log("there was an error on reset", error);
              this.props.form.setFields({
                email: {
                  value: values.email,
                  errors: [new Error()]
                }
              });
              this.setState({ loading: false });
            });
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <RequestResetMutation mutation={REQUEST_RESET_QUERY}>
        {(reset, { data }) => (
          <Form
            onSubmit={e => this.handleReset(e, reset)}
            className="login-form"
          >
            {this.state.done ? (
              <div style={{ textAlign: "center" }}>
                <Progress type="circle" percent={100} width={80} />
                <p style={{ marginTop: "1em" }}>
                  Check your email for password reset steps.
                </p>
                <p style={{ marginTop: "1em" }}>
                  <Link to="/login">Back to login</Link>
                </p>
              </div>
            ) : (
              <React.Fragment>
                <Logo />
                <FormItem>
                  {getFieldDecorator("email", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your mail adress!"
                      }
                    ]
                  })(
                    <Input
                      prefix={
                        <Icon
                          type="user"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      placeholder="Mail"
                      readOnly={this.state.loading}
                    />
                  )}
                </FormItem>
                <FormItem>
                  <Button
                    loading={this.state.loading}
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    Request Password reset
                  </Button>
                </FormItem>
              </React.Fragment>
            )}
          </Form>
        )}
      </RequestResetMutation>
    );
  }
}

export default Form.create<Props>()(ForgotForm);



// WEBPACK FOOTER //
// ./src/screens/Login/ForgotForm/ForgotForm.tsx